var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortstraddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H47",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 43L42.0941 43.8465L37.0234 44.1508H36.6928L36.5633 43.8465L32.7379 34.8529L26.2969 20.8078L19.2636 34.8744L19.1254 35.1508H18.8164H13.8164H13L13.371 34.4236L25.871 9.9236L26.3422 9L26.7715 9.9438L37.9161 34.4438L37.9206 34.454L40.1462 39.6508L40.5 40V40.5L41.5 43Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9989 44.5H15.3238L15.4558 44.2031L19.4558 35.2031L19.7683 34.5H18.9989H13.9989H13.6769L13.5437 34.7931L11.1769 40L10.4989 41.5L9.49895 43.5L9.29012 44L9.28906 44.2031L14.9989 44.5Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7682 45H37.4433L37 44L33.3113 35.7031L32.9988 35H33.7682H38.7682H39.0902L39.2234 35.2931L41.5 40L43.832 44.5L43.8308 44.7031L37.7682 45Z",
    fill: "#E94C69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.832 44.5L41.5 40L39.2234 35.2931L39.0902 35H38.7682H33.7682H32.9988L33.3113 35.7031L37 44L37.4433 45H37.7682L43.8308 44.7031L43.832 44.5ZM43.832 44.5V44.7031",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortstraddle);
export default __webpack_public_path__ + "static/media/short straddle.9989d9e30a2ed245b2eecf4082fc2589.svg";
export { ForwardRef as ReactComponent };